import { Flex, View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { UiPreferences } from "@/components/app/UiPreferences.tsx"
import Home from "@spectrum-icons/workflow/Home"
import { GlobalSearch } from "@/components/app/search/GlobalSearch.tsx"
import { UnitsPicker } from "@/components/app/UnitsPicker.tsx"
import { Button } from "@/components/wrappers/Aria/AriaWrapper.tsx"
import { useNavigate } from "react-router"
import { ProfileButton } from "@/components/app/ProfileButton.tsx"

export function NavigationBar() {
  return (
    <View
      backgroundColor="gray-200"
      paddingStart="size-150"
      paddingEnd="size-150"
      width="100%"
      maxHeight="size-550"
      overflow="hidden"
    >
      <Flex alignItems="center" justifyContent="space-between" wrap>
        <HomeButton />
        <GlobalSearch />
        <UserControls />
      </Flex>
    </View>
  )
}

export function UserControls() {
  return (
    <Flex alignItems="center">
      <UnitsPicker />
      <UiPreferences />
      <ProfileButton />
    </Flex>
  )
}

export function HomeButton() {
  const navigate = useNavigate()

  function onPress() {
    void navigate("/dashboard")
  }

  return (
    <Button onPress={onPress} aria-label="Home">
      <Home size="M" />
    </Button>
  )
}
